import DateField from '@/components/UI/Fields/HtmlInput/DateField';

import TextArea from './HtmlInput/TextArea';
import TextField from './HtmlInput/TextField';
import TimeField from './HtmlInput/TimeField';
import ValidationError from './HtmlInput/ValidationError';

type InputFieldType = {
  Text: typeof TextField;
  Time: typeof TimeField;
  Date: typeof DateField;
  TextArea: typeof TextArea;
  Error: typeof ValidationError;
};
const Input: InputFieldType = {
  Text: TextField,
  Time: TimeField,
  Date: DateField,
  TextArea,
  Error: ValidationError,
};
export default Input;
